module.exports = __webpack_public_path__ + "static/media/telegram-qrcode.52a5ee9d.png";